import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=65cd6d8b"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=65cd6d8b&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65cd6d8b')) {
      api.createRecord('65cd6d8b', component.options)
    } else {
      api.reload('65cd6d8b', component.options)
    }
    module.hot.accept("./Tabs.vue?vue&type=template&id=65cd6d8b", function () {
      api.rerender('65cd6d8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/Tabs.vue"
export default component.exports